/**
 * Generated runtime TestId mirror for frontend/src/components/shared/OwnersPicker.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const OwnersPickerTestIds = {
  btnAddOwner: "btn-add-owner",
  ownersEditor: "owners-editor",
  btnRemoveOwner: (index: number) => `btn-remove-owner-${index}`,
  btnRemoveOwnerPrefix: () => "btn-remove-owner-" as TestIdPrefix,
  comboboxOwnerParty: (index: number) => `combobox-owner-party-${index}`,
  comboboxOwnerPartyPrefix: () => "combobox-owner-party-" as TestIdPrefix,
  ownerRow: (index: number) => `owner-row-${index}`,
  ownerRowPrefix: () => "owner-row-" as TestIdPrefix,
  selectOwnerResponsibility: (index: number) => `select-owner-responsibility-${index}`,
  selectOwnerResponsibilityPrefix: () => "select-owner-responsibility-" as TestIdPrefix
} as const;
